export default __webpack_public_path__ + "static/media/Group8874.6ec55fe6.svg";